import React from 'react';

interface SuperMegaScreen3DIconProps {
  size?: number;
  color?: string;
}

export const SuperMegaScreen3DIcon = ({ size = 48, color = '#BC1A6C' }: SuperMegaScreen3DIconProps) => {
  const darkerColor = adjustBrightness(color, -30);
  const lighterColor = adjustBrightness(color, 30);

  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Shadow */}
      <ellipse cx="32" cy="58" rx="18" ry="3" fill="rgba(0,0,0,0.2)" />
      {/* Heavy base */}
      <rect x="18" y="52" width="28" height="5" rx="2" fill={darkerColor} />
      <rect x="18" y="50" width="28" height="5" rx="2" fill={color} />
      {/* Double support poles */}
      <rect x="22" y="36" width="4" height="16" fill={darkerColor} rx="1" />
      <rect x="23" y="36" width="4" height="16" fill={color} rx="1" />
      <rect x="38" y="36" width="4" height="16" fill={darkerColor} rx="1" />
      <rect x="39" y="36" width="4" height="16" fill={color} rx="1" />
      {/* Extra-large screen */}
      <rect x="4" y="4" width="52" height="32" rx="3" fill={color} />
      <path d="M56 4 L60 1 L60 33 L56 36 Z" fill={darkerColor} />
      <path d="M4 4 L8 1 L60 1 L56 4 Z" fill={lighterColor} />
      {/* Screen inner */}
      <rect x="7" y="7" width="46" height="26" rx="1" fill="white" opacity="0.25" />
      {/* Large play button */}
      <polygon points="26,14 26,26 38,20" fill="white" opacity="0.5" />
      {/* Top shine */}
      <rect x="4" y="4" width="52" height="5" rx="3" fill="white" opacity="0.15" />
      {/* "MEGA" indicator — extra frame accent */}
      <rect x="4" y="4" width="3" height="32" rx="1" fill="white" opacity="0.08" />
    </svg>
  );
};

function adjustBrightness(hex: string, amount: number): string {
  const num = parseInt(hex.replace('#', ''), 16);
  const r = Math.min(255, Math.max(0, (num >> 16) + amount));
  const g = Math.min(255, Math.max(0, ((num >> 8) & 0x00FF) + amount));
  const b = Math.min(255, Math.max(0, (num & 0x0000FF) + amount));
  return `#${(r << 16 | g << 8 | b).toString(16).padStart(6, '0')}`;
}
